/* src/app/jumbotron/jumbotron.component.css */
#jumbotron {
  text-align: center;
  margin-top: 0;
}
.profileContainer {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  padding: 3rem 1rem 1.25rem;
  background:
    linear-gradient(
      135deg,
      #0f1c2e 0%,
      #1f3b61 55%,
      #27536c 100%);
  color: #f5f7fa;
  box-shadow: 0 20px 50px rgba(15, 28, 46, 0.3);
  margin-bottom: 0;
}
.profilePic {
  position: relative;
  z-index: 1;
  width: 204px;
  height: 204px;
  background-image: url("./media/profilepic1.jpg");
  background-position: center 10%;
  background-size: 120%;
  border-radius: 100%;
  border: 6px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 15px 30px rgba(12, 23, 38, 0.35);
}
.particles {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
}
.particles ng-particles {
  width: 100%;
  height: 100%;
}
#jumbotron .uk-card {
  margin-top: 0;
  border-radius: 0;
}
#jumbotron .uk-card-title {
  font-size: 1.85rem;
  line-height: 1.2;
}
/*# sourceMappingURL=jumbotron.component.css.map */
